export default {
  init() {
    if ($('body').hasClass('single-evenement')) {
      $('iframe').iFrameResize({ log: true, checkOrigin: false, heightCalculationMethod: 'lowestElement' });
    }
  },
};
